// extracted by mini-css-extract-plugin
export default {"btnBox":"rLgrKdIZqQC5uynf5yXU"};